module.exports = __webpack_public_path__ + "img/alert.37ebefa4.svg";